module.exports = __webpack_public_path__ + "static/media/sidebar_menu_icon.28b1efbf.jpg";